import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-dialog-show-info',
  template: '{{ data }}'
})

export class DialogShowInfoComponent {
 constructor(@Inject(MD_DIALOG_DATA) public data: any) { }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dialogs/dialog-show-info.component.ts